// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { useDispatch, useSelector } from 'react-redux';

import { QuicknotesPlugin } from '../../../capacitor_plugins/quicknotes';

// Selectors
import { getCurrentUserQuickNotesRootBoardId } from '../../user/currentUserSelector';

// Constants
import { CAPACITOR_QUICKNOTES_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { createAndEditNewQuickNoteElement } from '../actions/quickNotesActions';
import { ElementType } from '../../../common/elements/elementTypes';

const useAttachCapacitorQuicknotes = () => {
    const dispatch = useDispatch();
    const quicknotesBoardId = useSelector(getCurrentUserQuickNotesRootBoardId);

    useEffect(() => {
        if (!Capacitor.isPluginAvailable(CAPACITOR_QUICKNOTES_PLUGIN)) return;

        QuicknotesPlugin.addListener('createNewNote', () => {
            dispatch(createAndEditNewQuickNoteElement(quicknotesBoardId, ElementType.CARD_TYPE));
        });

        QuicknotesPlugin.addListener('createNewTodo', () => {
            dispatch(createAndEditNewQuickNoteElement(quicknotesBoardId, ElementType.TASK_LIST_TYPE));
        });

        QuicknotesPlugin.addListener('createNewImage', () => {
            dispatch(createAndEditNewQuickNoteElement(quicknotesBoardId, ElementType.IMAGE_TYPE));
        });
    }, [quicknotesBoardId]);
};

export default useAttachCapacitorQuicknotes;
